
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import ListProducts from './ListProducts';
import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import SeaseonalCoktailScreen from './seasonalCocktail';
import SpecialityCocktail from './specialityCocktail';
import PeruvianClasic from './peruvianClasic';
import BeerScreen from './beer';
import SpiritsScreen from './spirits';

function Index({dishs2, setShowBar}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showSpecialitylCocktail, setShowSpecialitylCocktail] = useState(false);
    const [showSesonalCocktail, setShowSesonalCocktail] = useState(false);
    const [showPeruvianClasic, setshowPeruvianClasic] = useState(false);
    const [showBeer, setshowBeer] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showspirits, setShowSpirits] = useState(false);
    const [datachampana, setdatachampana] = useState(false);
    const [datawine, setdatawine] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 341) {
                setdatachampana(item);
            }
            if (item.id === 340) {
                setdatawine(item);
            }
        });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} goHome={setShowBar} setShowListProduct={setShowBar}>
                <div style={{ padding: '0 20px' }}>
                     <img
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140,
                        marginTop: -10,
                        }}
                    />
                     <p style={{color: 'white', textAlign: 'center', fontSize: 35}}>
                        BAR
                    </p>

                    <div
                        
                        style={{
                            display: 'flex',
                            marginTop: 20,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                            onClick={()=>setShowSesonalCocktail(true)}
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                        }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 8}}>
                                    SEASONAL
                                </p>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    COCKTAILS
                                </p>
                            </div>
                        </div>

                        <div
                           onClick={()=>setShowSpecialitylCocktail(true)}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 8}}>
                                SPECIAL
                            </p>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                COCKTAILS
                            </p>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display:'flex',
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                             onClick={()=>setshowPeruvianClasic(true)}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 8}}>
                                    PERUVIAN
                                </p>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    CLASSICS
                                </p>
                            </div>
                        </div>

                        <div
                             onClick={()=>setshowBeer(true)}
                            style={{
                                 display:'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                BEER
                            </p>
                            </div>
                        </div>
                    </div>

                    <div
                       
                        style={{
                            display: "flex",
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                             onClick={() => {
                            setdishs(datachampana)
                            setShowListProduct(true)
                        }}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                CHAMPAGNE
                            </p>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                            setdishs(datawine)
                            setShowListProduct(true)
                        }}
                            style={{
                                display: "flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                WINES
                            </p>
                            </div>
                        </div>
                    </div>
                     <div
                        style={{
                            display:"flex",
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                              onClick={()=>setShowSpirits(true)}
                            style={{
                                display:"flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    SPIRITS
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {showSpecials && <SpecialsScreen setShowHappy={setShowBar} setShowListProduct={setShowSpecials} />}

                
                {showSesonalCocktail && <SeaseonalCoktailScreen goHome={setShowBar} setShowListProduct={setShowSesonalCocktail} />}
                {showSpecialitylCocktail && <SpecialityCocktail goHome={setShowBar} setShowListProduct={setShowSpecialitylCocktail}  />}
                {showPeruvianClasic && <PeruvianClasic goHome={setShowBar} setShowListProduct={setshowPeruvianClasic} />}
                {showBeer && <BeerScreen goHome={setShowBar} setShowListProduct={setshowBeer} />}
                {showspirits && <SpiritsScreen goHome={setShowBar} setShowListProduct2={setShowSpirits} />}


                {showListProduct && <ListProducts
                    dishs={dishs}
                    goHome={setShowBar}
                    setShowListProduct={setShowListProduct}
                />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;